import { Utente } from 'src/app/shared/models/utente.model';
import { Resource } from 'src/app/shared/models/resource.model';
import { orderByModel } from 'src/app/shared/models/filter-data/order-by.model';
import { SingleFilter } from 'src/app/shared/models/filter-data/single-filter.model';
import { OperatorFilter } from 'src/app/shared/models/filter-data/operator-filter.model';

/**Interfaccia dello stato dell'applicazione per la sezione Utenti */
export interface State {
    /**Elenco degli utenti recuperati da BE */
    _elencoUtenti: Utente[];
    elencoFiltriUtenti: (SingleFilter | OperatorFilter);
    ordinamentoUtenti: orderByModel[];
    /**Errori nelle azioni della sezione utenti */
    errorUtenti: any;
    /**Utente selezionato sulla tabella utenti */
    utenteSelezionato: Utente;
    /**Risorse associate all'utente selezionato */
    elencoRisorse: Resource[];
    /**Elenco dei trattati disponibili */
    elencoTrattati: Resource[];
    displayAdd: boolean;
}

/**Stato iniziale della sezione Utenti dell'applicazione */
export const initialState: State = {} as State;